import { http } from "./http";

/**
 * Admin-only API client for `dbo.aiServerAgent` CRUD. Used by the
 * `/admin/aiagents` page in the SPA. Gating happens server-side on
 * `session.Kind == Admin` — the SPA still wraps the page in a
 * `<ProtectedRoute requireKind="Admin">` so a non-admin never even
 * lands here.
 */

export interface AiAgentListItem {
  aiServerAgentId: number;
  name: string;
  description: string | null;
  voicePresetKey: string | null;
  /** Legacy free-text voice name; surfaced read-only in the editor. */
  voiceName: string | null;
}

export interface AiAgentDetail {
  aiServerAgentId: number;
  name: string;
  description: string | null;
  instructions: string;
  welcomeMsg: string | null;
  voicePresetKey: string | null;
  voiceName: string | null;
  ttsModel: string;
  allowAgentConnect: boolean | null;
  allowHuntgroupConnect: boolean;
  allowProfileFetch: boolean;
}

export interface AiAgentPayload {
  name: string;
  description: string | null;
  instructions: string;
  welcomeMsg: string | null;
  voicePresetKey: string | null;
  voiceName: string | null;
  ttsModel: string;
  allowAgentConnect: boolean | null;
  allowHuntgroupConnect: boolean;
  allowProfileFetch: boolean;
}

export function listAiAgents(): Promise<{ items: AiAgentListItem[] }> {
  return http<{ items: AiAgentListItem[] }>("/api/admin/aiagents");
}

export function getAiAgent(id: number): Promise<AiAgentDetail> {
  return http<AiAgentDetail>(`/api/admin/aiagents/${id}`);
}

export function createAiAgent(payload: AiAgentPayload): Promise<{ id: number }> {
  return http<{ id: number }>("/api/admin/aiagents", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAiAgent(id: number, payload: AiAgentPayload): Promise<{ result: boolean }> {
  return http<{ result: boolean }>(`/api/admin/aiagents/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}
